import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class QuestionnaireView extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'questionnaire',
            data: null,
            loading: true,

            embeded: false,
            id: 1,
            step: 1,
            currentQuestionPosition: 0,
            fill: [],
            fillDone: 0,
            lastTimeSpan: new Date()
        }
    }
    componentDidMount() {
        if (this.state.data !== null) {
            this.state.data = this.jsonConverts(this.state.data);
            return;
        }
        this.httpPost('api/v1/questionnaire/get', {
            id: this.getCurrentFormId()
        })
            .then((data) => {

                data = this.jsonConverts(data);

                data.record.questions = data.record.questions.sort((a, b) => a.position - b.position);
                this.setState({
                    data,
                    loading: false,
                    step: (data.record.startPageDisplay == 1 ? 1 : 2)
                });
            });
    }
    fillDone(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost('api/v1/questionnaire/fill/', {
            fill: this.state.fill,
            id: this.getCurrentFormId()
        })
            .then((data) => {
                if (data.status == 1) {
                    this.setState({ fillDone: 1 });
                }
                else
                    this.showErorrMessage(data.message);
            })
    }

    getResponseTime() {
        var deff = Math.round(((new Date()).getTime() - (this.state.lastTimeSpan).getTime()) / 1000);
        this.state.lastTimeSpan = new Date();
        return deff;
    }
    setEnglishDateAnswer(question, option, columnId, e) {
        var selectedDate = new Date(e);
        var date = selectedDate.getFullYear() + "-" + selectedDate.getMonth() + 1 + "-" + selectedDate.getDate();
        this.setAnswer(question, option, columnId, { text: date, value: null })
    }
    setPersianDateAnswer(question, option, columnId, e) {
        var selectedDate = new Date(e);
        var date = selectedDate.getFullYear() + "-" + selectedDate.getMonth() + 1 + "-" + selectedDate.getDate();
        this.setAnswer(question, option, columnId, { text: this.g2j(date, 3), value: null });
    }
    setFileAnswer(question, option, columnId, e) {
        if (e.target.files.length == 0) {
            return;
        }
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            var bs64 = reader.result;
            this.setAnswer(question, option, columnId, { text: bs64, value: null });
        };
        reader.readAsDataURL(file);
    }
    setAnswer(question, option, columnId, e) {
        var fill = this.state.fill;
        var index = -1;

        //چون موقع انتخاب رادیو باتنها انتخاب های قبلی خالی نمیشند بایستی ابتدا همه پاسخهای مرتبط با این سوال رو حذف کنیم
        if (question.fieldType === 2) {
            if (question.format === 1) {
                var temp = [];
                fill.forEach((f, i) => {
                    if (f.questionId != question.id) temp.push(f);
                });
                fill = temp;
            }
        }
        if (question.fieldType === 4) {
            if (question.format === 1) {
                var temp = [];
                fill.forEach((f, i) => {
                    if (f.questionId != question.id || f.optionId != option.id) temp.push(f);
                });
                fill = temp;
            }
        }

        fill.forEach((f, i) => {
            if (question.fieldType === 4) {
                if (f.questionId == question.id && f.optionId == option.id && f.columnId == columnId) index = i;
            }
            else {
                if (!this.isNull(option)) {
                    if (f.questionId == question.id && f.optionId == option.id) index = i;
                }
                else {
                    if (f.questionId == question.id) index = i;
                }
            }
        });
        var textValue = '';
        var numberValue = null;
        var array_object = null;

        if (question.fieldType == 2 && question.format == 3) {
            numberValue = 0;
            e.forEach(ee => {
                if (!this.isBlank(textValue)) textValue += " ";
                textValue += ee.label;
                numberValue += ((this.isNull(ee.value) || isNaN(ee.value) || this.isBlank(ee.value)) ? 0 : parseFloat(ee.value));
            });
            array_object = e;
        }
        else {
            textValue = e.text;
            numberValue = ((this.isNull(e.value) || isNaN(e.value) || this.isBlank(e.value)) ? null : parseFloat(e.value));
        }
        if (index == -1) {
            fill.push({
                questionId: question.id,
                optionId: this.isNull(option) ? this.getDefaultGuid() : option.id,
                columnId: columnId,
                numberValue: numberValue,
                textValue: textValue,
                time_to_response: this.getResponseTime(),
                array_object: array_object,
                //این فیلد کمکی ui است
                questionPosition: this.state.currentQuestionPosition
            });
        }
        else {
            fill[index].numberValue = numberValue;
            fill[index].textValue = textValue;
            fill[index].array_object = array_object;
        }
        var final_fill = [];

        fill.forEach((f, i) => {
            if (!this.isBlank(f.textValue) || !this.isBlank(f.numberValue)) final_fill.push(f);
        });
        this.state.fill = final_fill;
    }
    getAnswer(question, option, columnId) {
        var fill = this.state.fill;
        var index = -1;
        fill.forEach((f, i) => {
            if (question.fieldType === 4) {
                if (f.questionId == question.id && f.optionId == option.id && f.columnId == columnId) index = i;
            }
            if (question.fieldType === 2) {
                if (question.format !== 3) {
                    if (f.questionId == question.id && f.optionId == option.id) index = i;
                }
                else {
                    if (f.questionId == question.id) index = i;
                }
            }
            if (question.fieldType === 1) {
                if (f.questionId == question.id) index = i;
            }
        });
        if (index == -1) {
            return { optionId: null, questionId: null, columnId: null, numberValue: null, textValue: null, array_object: [] };
        }
        else {
            return fill[index];
        }
    }
    start() {
        this.setState({ step: 2 });
    }
    showQuestion(questionIndex) {
        var question = this.state.data.record.questions[questionIndex];
        var show = true;
        var conditions = question.conditions;
        if (!this.isNull(conditions)) {
            var totalquestionsPoint = 0;
            var lastQuestionPoint = 0;

            this.state.fill.forEach(f => {
                if (f.questionPosition < questionIndex) {
                    if (!isNaN(f.numberValue)) totalquestionsPoint += f.numberValue;
                    if (f.questionPosition == questionIndex - 1 && !isNaN(f.numberValue)) {
                        lastQuestionPoint += f.numberValue;
                    }
                }
            });
            conditions.forEach(f => {
                if (f.type == 1) {
                    if ((lastQuestionPoint == f.value && f.op == 1) ||
                        (lastQuestionPoint >= f.value && f.op == 2) ||
                        (lastQuestionPoint <= f.value && f.op == 3) ||
                        (lastQuestionPoint > f.value && f.op == 4) ||
                        (lastQuestionPoint < f.value && f.op == 5)) { }
                    else {
                        show = false;
                    }
                }
                if (f.type == 2) {
                    if ((totalquestionsPoint == f.value && f.op == 1) ||
                        (totalquestionsPoint >= f.value && f.op == 2) ||
                        (totalquestionsPoint <= f.value && f.op == 3) ||
                        (totalquestionsPoint > f.value && f.op == 4) ||
                        (totalquestionsPoint < f.value && f.op == 5)) { }
                    else {
                        show = false;
                    }
                }
                if (f.type == 3) {
                    if ((!this.isNull(this.state.currentPerson) && f.op == 1) ||
                        (this.isNull(this.state.currentPerson) && f.op == 2)) { }
                    else {
                        show = false;
                    }
                }
            });
        }
        //اگه شرط نمایش نداشته باشه بایستی کلیه پاسخ های ذخیره شده برای این سوال هم حذف شوند
        if (show == false) {
            var fill = this.state.fill;
            var tempFill = [];
            fill.forEach(f => {
                if (f.questionId != question.id) {
                    tempFill.push(f);
                }
            });
            this.state.fill = tempFill;
        }
        return show;
    }
    hasAnyFill(questionId) {
        var find = false;
        this.state.fill.forEach(f => {
            if (f.questionId == questionId) {
                if (!this.isBlank(f.textValue) || !this.isBlank(f.numberValue)) find = true;
            }
        });
        return find;
    }
    checkRequiredDone(question) {
        if (question.fieldType == 1) {

            var fill = this.getAnswer(question);
            if (question.required == 1) {
                if (this.isNull(fill)) {
                    return (this.state.data.record.displayMode == 1 ? "پاسخ به این سوال اجباری است" : "پاسخ به سوال " + this.htmlToString(question.question) + " اجباری است");
                }
                if (this.isBlank(fill.textValue) && this.isBlank(fill.numberValue)) {
                    return (this.state.data.record.displayMode == 1 ? "پاسخ به این سوال اجباری است" : "پاسخ به سوال " + this.htmlToString(question.question) + " اجباری است");
                }
            }

            if (this.isNull(fill)) return;

            if (question.format == 2 || question.format == 3) {

                if (isNaN(fill.numberValue)) return (this.state.data.record.displayMode == 1 ? "فقط عدد مورد قبول می باشد" : "در سوال " + this.htmlToString(question.question) + " فقط عدد مورد قبول می باشد");

                if (question.range.includes(";")) {

                    var parts = question.range.split(";");
                    if (!this.isEmpty(parts[0])) {
                        if (parseFloat(fill.numberValue) < parseFloat(parts[0])) {
                            return "کمتر از عدد " + parts[0] + " مورد قبول نیست";
                        }
                    }
                    if (!this.isEmpty(parts[1])) {
                        if (parseFloat(fill.numberValue) > parseFloat(parts[1])) {
                            return "بزرگتر از عدد " + parts[1] + " مورد قبول نیست";
                        }
                    }
                }
            }
            if (question.format == 4) {
                if (!this.isBlank(fill.textValue) && !this.isEmail(fill.textValue)) return (this.state.data.record.displayMode == 1 ? "فرمت ایمیل وارد شده صحیح نمی باشد" : "فرمت ایمیل وارد شده در سوال " + this.htmlToString(question.question) + " صحیح نمی باشد");
            }
            if (question.format == 5) {
                if (!this.isBlank(fill.textValue) && !this.isMobile(fill.textValue)) return (this.state.data.record.displayMode == 1 ? "فرمت شماره موبایل وارد شده صحیح نمی باشد" : "فرمت شماره موبایل وارد شده در سوال " + this.htmlToString(question.question) + " صحیح نمی باشد");
            }
            if (question.format == 6) {
                var re = /[a-z0-9-\.]+\.[a-z-ا-ی]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?$/;
                if (!this.isBlank(fill.textValue) && !re.test(fill.textValue)) return (this.state.data.record.displayMode == 1 ? "آدرس وبسایت وارد شده صحیح نمی باشد" : "آدرس وبسایت وارد شده در سوال " + this.htmlToString(question.question) + " صحیح نمی باشد");
            }
            if (question.format == 7) {
                if (!this.isBlank(fill.textValue) && this.isIranNationalCode(fill.textValue)) return (this.state.data.record.displayMode == 1 ? "کد ملی وارد شده صحیح نمی باشد" : "کد ملی وارد شده در سوال " + this.htmlToString(question.question) + " صحیح نمی باشد");
            }
        }
        if (question.fieldType == 2) {

            var fillCounts = 0;
            for (var i = 0; i < question.options.length; i++) {
                var fill = this.getAnswer(question, question.options[i]);

                if (!this.isNull(fill)) {
                    if (!this.isBlank(fill.textValue) || !this.isBlank(fill.numberValue)) {
                        fillCounts++;
                    }
                }
            }

            if (question.required == 1) {
                if (fillCounts <= 0) {
                    return (this.state.data.record.displayMode == 1 ? "پاسخ به این سوال اجباری است" : "پاسخ به سوال " + this.htmlToString(question.question) + " اجباری است");
                }
            }

            if (!this.isBlank(question.maxSelect) && question.maxSelect != '0') {
                if (parseInt(question.maxSelect) < fillCounts) {
                    return (this.state.data.record.displayMode == 1 ? "حداکثر مجاز به انتخاب " + question.maxSelect + "گزینه هستید" : "در سوال " + this.htmlToString(question.question) + " حداکثر مجاز به انتخاب " + question.maxSelect + "گزینه هستید");
                }
            }

            for (var i = 0; i < question.options.length; i++) {
                var op = question.options[i];
                var fill = this.getAnswer(question, op);

                if (this.isNull(fill)) return;

                if (question.format == 5) {
                    if (isNaN(fill.numberValue)) return (this.state.data.record.displayMode == 1 ? "فقط عدد مورد قبول می باشد" : "در سوال " + this.htmlToString(question.question) + " فقط عدد مورد قبول می باشد");

                    if (question.range.includes(";")) {
                        var parts = question.range.split(";");
                        if (!this.isEmpty(parts[0])) {
                            if (parseFloat(fill.numberValue) < parseFloat(parts[0])) {
                                return "کمتر از عدد " + parts[0] + " مورد قبول نیست";
                            }
                        }
                        if (!this.isEmpty(parts[1])) {
                            if (parseFloat(fill.numberValue) > parseFloat(parts[1])) {
                                return "بزرگتر از عدد " + parts[1] + " مورد قبول نیست";
                            }
                        }
                    }
                }
            }
        }
        if (question.fieldType == 4) {

            if (question.required == 1) {
                for (var i = 0; i < question.options.length; i++) {
                    var fillCounts = 0
                    for (var j = 0; j < question.columns.length; j++) {
                        var fill = this.getAnswer(question, question.options[i], question.columns[j].id);
                        if (!this.isNull(fill)) {
                            if (!this.isBlank(fill.textValue) || !this.isBlank(fill.numberValue)) {
                                fillCounts++;
                            }
                        }
                    }
                    if (fillCounts <= 0)
                        return (this.state.data.record.displayMode == 1 ? "پاسخ به همه گزینه ها اجباری است" : "پاسخ به همه گزینه های سوال " + this.htmlToString(question.question) + " اجباری است");
                }
            }

            if (!this.isBlank(question.maxSelect) && question.maxSelect != '0') {
                for (var i = 0; i < question.options.length; i++) {
                    var fillCounts = 0
                    for (var j = 0; j < question.columns.length; j++) {
                        var fill = this.getAnswer(question, question.options[i], question.columns[j].id);
                        if (!this.isNull(fill)) {
                            if (!this.isBlank(fill.textValue) || !this.isBlank(fill.numberValue)) {
                                fillCounts++;
                            }
                        }
                    }
                    if (parseInt(question.maxSelect) < fillCounts) {
                        return (this.state.data.record.displayMode == 1 ? "حداکثر مجاز به انتخاب " + question.maxSelect + "گزینه در هر ردیف هستید" : "در سوال " + this.htmlToString(question.question) + " حداکثر مجاز به انتخاب " + question.maxSelect + "گزینه در هر ردیف هستید");
                    }
                }
            }

            for (var i = 0; i < question.options.length; i++) {
                for (var j = 0; j < question.columns.length; j++) {
                    var fill = this.getAnswer(question, question.options[i], question.columns[j].id);

                    if (this.isNull(fill)) return;

                    if (question.format == 5) {
                        if (isNaN(fill.numberValue)) return (this.state.data.record.displayMode == 1 ? "فقط عدد مورد قبول می باشد" : "در سوال " + this.htmlToString(question.question) + " فقط عدد مورد قبول می باشد");

                        if (question.range.includes(";")) {
                            var parts = question.range.split(";");
                            if (!this.isEmpty(parts[0])) {
                                if (parseFloat(fill.numberValue) < parseFloat(parts[0])) {
                                    return "کمتر از عدد " + parts[0] + " مورد قبول نیست";
                                }
                            }
                            if (!this.isEmpty(parts[1])) {
                                if (parseFloat(fill.numberValue) > parseFloat(parts[1])) {
                                    return "بزرگتر از عدد " + parts[1] + " مورد قبول نیست";
                                }
                            }
                        }
                    }
                }
            }
        }
        return "";
    }
    nextQuestion(from_condition = 0) {
        if (this.state.data.record.displayMode == 1 && from_condition == 0) {
            var resualt = this.checkRequiredDone(this.state.data.record.questions[this.state.currentQuestionPosition]);
            if (resualt != '') {
                this.showErorrMessage(resualt);
                return;
            }
        }
        else {
            if (from_condition == 0) {
                var hasErorrShow = 0;
                this.state.data.record.questions.forEach(q => {
                    var resualt = this.checkRequiredDone(q);
                    if (resualt != '') {
                        this.showErorrMessage(resualt);
                        hasErorrShow = 1;
                    }
                });
                if (hasErorrShow == 1) return;
            }
        }

        if (this.state.data.record.displayMode == 2) {
            if (typeof window !== "undefined") window.scrollTo(0, 0);

            if (this.state.data.record.displayResualt == 0)
                this.fillDone();
            else
                this.setState({ step: 3 });
        }

        if (this.state.currentQuestionPosition == this.state.data.record.questions.length - 1) {
            if (typeof window !== "undefined") window.scrollTo(0, 0);

            if (this.state.data.record.displayResualt == 0)
                this.fillDone();
            else
                this.setState({ step: 3 });
        }
        else {
            if (this.showQuestion(this.state.currentQuestionPosition + 1))
                this.setState({ currentQuestionPosition: this.state.currentQuestionPosition + 1 });
            else {
                this.state.currentQuestionPosition = this.state.currentQuestionPosition + 1;
                this.nextQuestion(1);
            }
        }
    }
    prevQuestion() {
        if (this.state.currentQuestionPosition == 0)
            this.setState({ step: 1 });
        else {
            if (this.showQuestion(this.state.currentQuestionPosition - 1))
                this.setState({ currentQuestionPosition: this.state.currentQuestionPosition - 1 });
            else {
                this.state.currentQuestionPosition = this.state.currentQuestionPosition - 1;
                this.prevQuestion();
            }
        }
    }
    getOptionText(options, optionId) {
        var text = '';
        options.forEach(f => {
            if (f.id == optionId) text = f.text;
        });
        return text;
    }
    renderResualt() {
        var resualt = [];
        var rowCounter = 1;
        this.state.data.record.questions.forEach(question => {
            if (this.hasAnyFill(question.id)) {
                resualt.push(
                    <div className='py-2'>
                        <div className='flex font-bold' style={{ color: this.state.data.record.style.questionColor }}>{rowCounter}. <div dangerouslySetInnerHTML={{ __html: question.question }}></div></div>
                        {question.fieldType == 1 && <span style={{ color: this.state.data.record.style.answerColor, "white-space": "break-spaces" }}>{(question.format == 2 || question.format == 3) ? this.getAnswer(question, null, null).numberValue : question.format == 11 ? (this.isBlank(this.getAnswer(question, null, null).textValue) ? "" : "فایل جهت بارگذاری انتتخاب شده است") : this.getAnswer(question, null, null).textValue}</span>}

                        <div className='flex flex-col' style={{ color: this.state.data.record.style.questionColor }}>
                            {(question.fieldType == 2) && <div className='flex flex-wrap' style={{ color: this.state.data.record.style.answerColor }}>
                                {(question.format == 3) ? this.getAnswer(question, null, null).textValue
                                    :
                                    question.options.map(op =>
                                        (this.isBlank(this.getAnswer(question, op, null).textValue) && this.isBlank(this.getAnswer(question, op, null).numberValue)) ?
                                            null
                                            :
                                            <div className='m-2'>
                                                {(question.format == 1 || question.format == 2) && this.getOptionText(question.options, this.getAnswer(question, op, null).optionId)}
                                                {(question.format == 4) && <p>{op.text}: {this.getAnswer(question, op, null).textValue}</p>}
                                                {(question.format == 5) && <p>{op.text}: {this.getAnswer(question, op, null).numberValue}</p>}
                                            </div>
                                    )
                                }
                            </div>}
                        </div>

                        {(question.fieldType == 4) &&
                            <table className='text-center'>
                                <thead>
                                    <tr>
                                        <th className='p-1' style={{ "font-size": "1rem", "line-height": "2rem" }}></th>
                                        {question.columns.sort((a, b) => a.position - b.position).map(c => <th className='p-1' style={{ "font-size": "1rem", "line-height": "2rem", "color": this.state.data.record.style.questionColor }}>{c.caption}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {question.options.map(op =>
                                        <tr>
                                            <td className='p-1' style={{ "font-size": "1rem", "line-height": "2rem", "color": this.state.data.record.style.questionColor }}>{op.text}</td>
                                            {question.columns.sort((a, b) => a.position - b.position).map(c =>
                                                <td className='p-1' style={{ color: this.state.data.record.style.answerColor }}>
                                                    {(question.format == 1 || question.format == 2) && !this.isBlank(this.getAnswer(question, op, c.id).textValue) ? this.getSVGIcon("check", "inline h-4 w-4 mx-1 fill-current") : ""}
                                                    {(question.format == 4) && this.getAnswer(question, op, c.id).textValue}
                                                    {(question.format == 5) && this.getAnswer(question, op, c.id).numberValue}
                                                </td>
                                            )}
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        }
                    </div>
                );
                rowCounter++;
            }
        });
        return <div>{resualt}</div>
    }
    renderForm() {
        return <div className="mx-auto p-4 relative pb-12">
            {this.state.data.record.status !== 2 && this.isNull(this.state.data.currentPerson) && this.state.data.record.type === 2 ?
                <div>
                    <p className='text-xl text-center mb-4'>جهت تکمیل این پرسشنامه الزامی است که شما وارد حساب کاربری خود در سایت شوید.</p>
                </div>
                : [
                    this.state.data.record.status === 2 ?
                        this.state.data.record.questions.map(question => this.renderQuestionBox(question, false, this.state.data.record.style))
                        :
                        this.state.step === 1 &&
                        this.renderFirstPage(this.state.data.record)
                    ,
                    this.state.step === 2 ?
                        this.state.data.record.displayMode == 1 ?
                            this.renderQuestionBox(this.state.data.record.questions[this.state.currentQuestionPosition], false, this.state.data.record.style)
                            :
                            this.state.data.record.questions.map(question => this.renderQuestionBox(question, false, this.state.data.record.style))
                        : null
                    ,
                    this.state.step === 3 &&
                    <div id="Questionnaire" style={{ "font-size": "1.4rem", "line-height": "2.8rem", "width": "100%", "max-width": "45rem", "margin": "0 auto", "padding": "2rem 0" }}>
                        <p style={{ color: this.state.data.record.style.questionColor }}>با تشکر از شما بابت پاسخگویی به این پرسش نامه, نتیجه پاسخ های شما به شرح ذیل است.لطفا صحت پاسخ های خود را بررسی نموده و دکمه ارسال را بزنید</p>
                        {this.renderResualt()}
                        <div className="my-8 text-center">
                            <span onClick={e => this.setState({
                                step: (this.state.data.record.startPageDisplay == 1 ? 1 : 2),
                                currentQuestionPosition: 0
                            })} className="hand btn btn-warning mx-2">برگشت به ابتدا</span>
                                <span onClick={e => this.fillDone(e)} className="hand btn btn-success">ارسال پرسشنامه</span>
                        </div>
                    </div>
                ]}
        </div>
    }
    renderSuccesSend() {
        return <div className="mx-auto p-4 relative ">
            <div className={'text-green-600 font-bold text-center my-4'}>
                {this.state.data.record.finishPageDisplay === 1 ?
                    this.renderLastPage(this.state.data.record, false)
                    :
                    <div className='flex flex-col space-y-4 min mt-8'>پرسشنامه تکمیل شده توسط شما با موفقیت ارسال گردید</div>
                }
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <div className={this.state.data.record.status == 0 ? "pt-4" : ""} style={{ "min-height": "100%", "font-size": "0.9rem", "line-height": "1.8rem", "backgroundColor": this.state.data.record.style.backgroundColor }}>
                    {this.state.data.record.status == 0 && <p className="alert alert-fill alert-danger alert-icon text-center">این پرسشنامه هنوز منتشر نشده و امکان پاسخگویی ندارد</p>}
                    {this.state.data.record.titleDisplay === 1 && <p className='text-center text-xl pt-4 font-bold'>{this.state.data.record.title}</p>}

                    {(this.state.data.record.status !== 2 && this.state.data.filled > 0) ?
                        <div className="mx-auto p-4 relative pb-12">
                            <div className='bg-red-100 text-red-500 rounded p-3 mx-2 text-center leading-7 text-xl'>
                                <p>شما قبلا این پرسشنامه را تکمیل نموده اید. هرکاربر فقط یکبار میتوانید به پرسشنامه پاسخ دهد.</p>
                            </div>
                        </div>
                        :
                        this.state.fillDone === 0 ?
                            this.renderForm()
                            :
                            this.renderSuccesSend()
                    }

                </div>,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}